import { render, staticRenderFns } from "./BackToHome.vue?vue&type=template&id=c6a82f18&scoped=true&"
var script = {}
import style0 from "./BackToHome.vue?vue&type=style&index=0&id=c6a82f18&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a82f18",
  null
  
)

export default component.exports